












































































import { Route } from 'vue-router';
import { Component, Vue } from 'vue-property-decorator';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import { ErrorCode } from '@/resources/error/ErrorCode';
import { CameraChildErrorCode } from '@/resources/error/CameraChildErrorCode';
import IdDocType from '@/resources/enum/IdDocType';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import FooterButton from '@/components/FooterButton.vue';
import ModalImage from '@/components/ModalImage.vue';

@Component({
  components: {
    CameraPageHeader,
    FooterButton,
    ModalImage
  },
  beforeRouteLeave(to: Route, from: Route, next: () => void) {
    // 戻る場合は自動撮影を停止し、進む場合は自動撮影を再開する
    const keys1: string[] = from.path.split('/');
    const keys2: string[] = to.path.split('/');
    const isBack: boolean = keys1[2] === keys2[2];
    this.$store.commit('camera/isDetectStop', isBack);
    next();
  }
})
export default class Page extends Vue {
  private isLoading: boolean = false;
  private checkedList: boolean[] = [];
  private photoAspectRatio: number = -1;
  private scrollerHeight: number = 0;
  private dynamicAreaHeight: number = 0;
  private zoomHeaderHeight: number = 0;
  private zoomImageSrc: string = '';
  private isZoomOpen: boolean = false;

  private get pageTitle(): string {
    if (this.isGpDocPage) {
      const pageCurr: number = this.$store.getters['camera/gpdocPageCurr'];
      const pageLast: number = this.$store.getters['camera/gpdocPageLast'];
      return this.$t('cameraCameraChildConfirmation.PageHeaderGpdoc', { pageCurr, pageLast }) as string;
    } else if (this.isOpDocPage) {
      const pageCurr: number = this.$store.getters['camera/opdocPageCurr'];
      const pageLast: number = this.$store.getters['camera/opdocPageLast'];
      return this.$t('cameraCameraChildConfirmation.PageHeaderOpdoc', { pageCurr, pageLast }) as string;
    } else {
      return this.$t('cameraCameraChildConfirmation.PageHeaderNormal') as string;
    }
  }

  private get isIdDocBack(): boolean {
    return this.$store.state.camera.shootType === 'identity-document-back';
  }

  private get isIdDocPassport(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.PassportHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTi) return true;
    return false;
  }

  private get isGpDocPage(): boolean {
    return this.$store.getters['camera/isGpdoc'];
  }

  private get isOpDocPage(): boolean {
    return this.$store.getters['camera/isOpdoc'];
  }

  private get isGeneralBook(): boolean {
    return this.$store.getters['camera/isGeneralBook'];
  }

  private get confirmationList(): string[] {
    const key: string = this.$store.state.camera.i18nKeyConfirmationListArray;

    let list = (this.$t(key) as { [key: number]: string }) as string[];

    // json形式のi18n辞書ファイルで、配列形式の文言の中の変数は$t関数で置き換えられないので、ここで置換する
    list = list.map(item => item.replace('{documentName}', this.$store.state.camera.documentName));

    return list;
  }

  private get isAllChecked(): boolean {
    return this.checkedList.every(checked => checked);
  }

  private get idGpdocLastCheck(): boolean {
    const pageCurr: number = this.$store.getters['camera/gpdocPageCurr'];
    const pageLast: number = this.$store.getters['camera/gpdocPageLast'];
    return pageCurr >= pageLast;
  }

  private get idOpdocLastPageCheck(): boolean {
    const pageCurr: number = this.$store.getters['camera/opdocPageCurr'];
    const pageLast: number = this.$store.getters['camera/opdocPageLast'];
    return pageCurr >= pageLast;
  }

  private get idOpdocLastTermCheck(): boolean {
    const termCurr: number = this.$store.getters['camera/opdocTermCurr'];
    const termLast: number = this.$store.getters['camera/opdocTermLast'];
    return termCurr >= termLast;
  }

  public get photoHeight(): number {
    if (this.photoAspectRatio < 0) return 0;
    const displayWidth: number = this.$store.state.camera.displayWidth;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    if (displayWidth <= 0 || displayHeight <= 0) return 0;
    // 画面高さから取りうる画像高さ
    const pageHeaderHeight: number = this.$store.state.camera.headerHeight;
    const imageMarginHeight: number = this.$store.getters['camera/isPC'] ? 70 : 20;
    const totalHeight: number = pageHeaderHeight + imageMarginHeight + this.dynamicAreaHeight;
    const maxPhotoHeight: number = displayHeight - totalHeight;
    // 画面幅から計算する画像高さ
    const photoMarginHorizontal: number = 20 + (this.isGpDocPage || this.isOpDocPage || this.isGeneralBook ? 60 : 0);
    const basePhotoWidth: number = Math.min(displayWidth - photoMarginHorizontal * 2, 500);
    const basePhotoHeight: number = basePhotoWidth / this.photoAspectRatio;
    // 画像高さを計算する
    const photoHeight: number = Math.min(basePhotoHeight, maxPhotoHeight);
    const minPhotoHeight: number = 100;
    return Math.max(photoHeight, minPhotoHeight);
  }

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  public async created(): Promise<void> {
    // ページマウント時の設定
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }

  public async mounted(): Promise<void> {
    this.checkedList = new Array(this.confirmationList.length).fill(false);

    // リロードしてトリムされた写真がなければ取得し直す
    let base64: string = this.$store.state.camera.trimmedPhoto[this.$store.state.camera.shootType];
    if (!base64) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('camera/storeTrimmedPhotoData');
        base64 = this.$store.state.camera.trimmedPhoto[this.$store.state.camera.shootType];
      } catch (error) {
        if (error instanceof ApiCancelError) {
          // キャンセルは握りつぶす
        } else if (error instanceof ApiModalError) {
          // clientRetryableで処理したエラーは握りつぶす
        } else throw error;
      } finally {
        this.isLoading = false;
      }
    }

    if (this.isIdDocPassport && this.isIdDocBack) {
      // パスポート所持人記入欄ページの場合は画像を上半分に加工
      base64 = await new Promise((resolve: (image: HTMLImageElement) => void): void => {
        const image: HTMLImageElement = window.document.createElement('img');
        image.addEventListener('load', () => resolve(image));
        image.src = base64;
      }).then((image: HTMLImageElement): string => {
        const canvas: HTMLCanvasElement = window.document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = Math.floor(image.height / 2);
        const context: CanvasRenderingContext2D = canvas.getContext('2d')!;
        context.drawImage(image, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        const type: string = base64.substring(5, base64.indexOf(';'));
        return canvas.toDataURL(type);
      });
    }

    // トリムされた写真を表示してアスペクト比を取得
    this.photoAspectRatio = await new Promise((resolve: (aspect: number) => void): void => {
      const photo: HTMLImageElement = this.$el.getElementsByTagName('img').item(0) as HTMLImageElement;
      photo.addEventListener('load', () => resolve(photo.naturalWidth / photo.naturalHeight));
      photo.src = base64;
    });

    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const checkArea: HTMLDivElement = this.$el.getElementsByClassName('check-area').item(0) as HTMLDivElement;
    const pageFooter: HTMLDivElement = this.$el.getElementsByClassName('page-footer').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    const checkAreaRect: DOMRect = checkArea.getBoundingClientRect() as DOMRect;
    const pageFooterRect: DOMRect = pageFooter.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
    this.dynamicAreaHeight = checkAreaRect.height + pageFooterRect.height;
  }

  private onZoomOpen(): void {
    this.zoomHeaderHeight = Math.max(0, this.$store.state.camera.headerHeight - this.$el.scrollTop);
    this.zoomImageSrc = (this.$el.getElementsByTagName('img').item(0) as HTMLImageElement).src;
    this.isZoomOpen = true;
  }

  private onZoomClose(): void {
    this.isZoomOpen = false;
  }

  private onRestartConfirmationOpen(): void {
    this.$buefy.dialog.confirm({
      title: this.$t('cameraCameraChildConfirmation.restartConfirmation.title') as string,
      message: this.$t('cameraCameraChildConfirmation.restartConfirmation.message') as string,
      confirmText: this.$t('cameraCameraChildConfirmation.restartConfirmation.ok') as string,
      cancelText: this.$t('cameraCameraChildConfirmation.restartConfirmation.cancel') as string,
      onConfirm: this.onRestart
    });
  }

  private onRestart(): void {
    if (this.isGpDocPage || this.isOpDocPage) {
      this.$router.push(this.$store.getters['camera/locationShoot']);
    } else {
      this.$router.push(this.$store.getters['camera/locationIntroduction']);
    }
  }

  // 確認した旨を送信して次の撮影へ進む
  private async onNext(isSkip: boolean): Promise<void> {
    try {
      this.isLoading = true;
      await this.$store.dispatch('camera/storeConfirm');
      this.$store.commit('camera/resetRetryCount');
      if (isSkip) {
        this.$router.push(this.$store.getters['camera/locationSkip']);
      } else {
        this.$router.push(this.$store.getters['camera/locationNext']);
      }
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
